class InviewEvent {
  constructor(el, opt){
    this.el = "." + el;
    this.all = this.el + '-all';
    this.eachUp = this.el + '-each';
    this.eachSequence = this.el.slice(1) + '-each-sequence';
    this.eachGroup = this.el + '-each-group';
    this.eachItem = this.el + '-eachItem';
    this.eachItemFast = this.el + '-eachItem-fast';
    this.eachItemDelay = this.el + '-eachItem-delay';
    if($(this.el).length > 0){
      this.event();
    }
  }
  event() {
    let options = {
      threshold: [0, 0.05, 0.1, 1]
    }
    let optionsAll = {
      threshold: [0, 0.9, 1]
    }
    const observerEnter = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        const item = entry.target;
        if(entry.intersectionRatio >= 0.05){
          item.classList.add('is-inview');
          if(item.classList.contains(this.eachSequence)){
            this.inviewEachSequence(item);
          } else if(item.classList.contains('js-inview-each')){
            this.inviewEachUp(item);
          }
          if(item.classList.contains('js-inview-lottie')){
            this.inviewLottie(item);
          }
          observerEnter.unobserve(item);
        }
      });
    }, options);
    const observerAll = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        const item = entry.target;
        if(entry.intersectionRatio >= 0.9){
          item.classList.add('is-inview');
          if(item.classList.contains('js-inview-each')){
            this.inviewEachUp(item);
          }
          observerAll.unobserve(item);
        } else {
          item.classList.remove('is-inview');
        }
      });
    }, optionsAll);
    const inviewItem = document.querySelectorAll(this.el);
    const inviewAllItem = document.querySelectorAll(this.all);
    inviewItem.forEach((e)=>{
      observerEnter.observe(e);
    });
    inviewAllItem.forEach((e)=>{
      observerAll.observe(e);
    });
  }
  inviewEachUp(item){
    $(item).find(this.eachItem).each((i,el)=>{
      gsap.to($(el), {
        // duration: 0.8,
        // alpha: 1,
        delay: (0.2 * i),
        // y: 0,
        // x: 0,
        onComplete: ()=>{
          $(el).addClass('is-inview');
        }
      });
    });
    $(item).find(this.eachItemFast).each((i,el)=>{
      gsap.to($(el), {
        // duration: 0.8,
        // alpha: 1,
        delay: (0.1 * i),
        // y: 0,
        // x: 0,
        onComplete: ()=>{
          $(el).addClass('is-inview');
        }
      });
    });
    $(item).find(this.eachItemDelay).each((i,el)=>{
      gsap.to($(el), {
        // duration: 0.8,
        // alpha: 1,
        delay: (0.5 * i),
        // y: 0,
        // x: 0,
        onComplete: ()=>{
          $(el).addClass('is-inview');
        }
      });
    });
  }
  inviewEachSequence(item){
    const scopeSelector = item.getAttribute('data-inview-sequence-scope');
    const scope = scopeSelector
      ? (item.closest(scopeSelector) || document.querySelector(scopeSelector))
      : item;
    if(!scope) return;

    const isSp = window.matchMedia('(max-width: 767px)').matches;
    const getOrder = (el) => {
      if(isSp && el.dataset.inviewOrderSp != null){
        return Number(el.dataset.inviewOrderSp);
      }
      return Number(el.dataset.inviewOrder || 0);
    };
    const groups = [...scope.querySelectorAll(this.eachGroup)].sort((a, b) => {
      return getOrder(a) - getOrder(b);
    });
    if(!groups.length) return;

    const delayStep = 0.2;
    const defaultWait = 0.3;

    const getVisibleItems = (group) => {
      const items = group.classList.contains('js-inview-eachItem')
        ? [group]
        : [...group.querySelectorAll(this.eachItem)];
      return items.filter((el) => window.getComputedStyle(el).display !== 'none');
    };

    const animateGroup = (group) => {
      return new Promise((resolve) => {
        const items = getVisibleItems(group);
        if(!items.length){
          resolve();
          return;
        }
        const wait = group.dataset.inviewWait != null
          ? Number(group.dataset.inviewWait)
          : defaultWait;
        items.forEach((el, i) => {
          gsap.to(el, {
            delay: delayStep * i,
            onComplete: () => {
              el.classList.add('is-inview');
              if(i === items.length - 1){
                gsap.delayedCall(wait, resolve);
              }
            }
          });
        });
      });
    };

    (async () => {
      for(const group of groups){
        await animateGroup(group);
      }
    })();
  }
  inviewLottie(item){
    if($(item).hasClass('js-lottie-flow')) {
      lottie.flow();
    }
    if($(item).hasClass('js-lottie-no01')) {
      lottie.no01();
    }
    if($(item).hasClass('js-lottie-no02')) {
      lottie.no02();
    }
    if($(item).hasClass('js-lottie-no03')) {
      lottie.no03();
    }
    if($(item).hasClass('js-lottie-no04')) {
      lottie.no04();
    }
    if($(item).hasClass('js-lottie-no05')) {
      lottie.no05();
    }
    if($(item).hasClass('js-lottie-no06')) {
      lottie.no06();
    }
    if($(item).hasClass('js-lottie-no07')) {
      lottie.no07();
    }
  }
}
